import { HttpClient, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
import * as CFormsSearch from '@core/custom-forms/models/field-search.model';

@Injectable({
    providedIn: 'root'
})
export class CustomFormsRequests {
    constructor(private http: HttpClient, private urlSrv : UrlService) {}

    filterLabels$ = () : Observable<Objects.Label[]> =>
        this.http.get<Objects.Label[]>(this.urlSrv.build("/labels"));

    filterStatus$ = () : Observable<Objects.Status[]> =>
        this.http.get<Objects.Status[]>(this.urlSrv.build("/versions/status"));

    loadCategories$ = () : Observable<Objects.LabelsGroup[]> => 
	    this.http.get<Objects.LabelsGroup[]>(this.urlSrv.build("/labels/categories"));

    loadUsers$ = () : Observable<Objects.User[]> => 
	    this.http.get<Objects.User[]>(this.urlSrv.build("/users"));

    // searchArtworks$ = (search: string) :  Observable<Objects.Version[]> => {
    //     let query = {term: search, page:"1", limit: '50'};
    //     let p = new HttpParams();
    //     Object.keys(query).forEach(key => p = p.set(key, query[key]) );

	//     return this.http.get<Objects.Version[]>(this.urlSrv.build("/versions"), { params: p})
    // };

    searchArtworks$ = (params: CFormsSearch.SearchQueryParams, page: number, limit: number, vid: number | string | null) : Observable<Objects.Version[]> => {
        let query = {...params, page: page.toString(), limit: limit.toString()};
        
        if(vid != null) {
            query['q'] = query.hasOwnProperty('q')? query['q'] + "+id:" + vid.toString() : "id:" + vid.toString();
            query['page'] = "1";
        }

        let p = new HttpParams();
        Object.keys(query).forEach(key => p = p.set(key, query[key]) );

        return this.http.get<Objects.Version[]>(this.urlSrv.build("/versions"), { params: p});
    }

}
